(() => {
  if (window.nutraceneAccordionReady) return;
  window.nutraceneAccordionReady = true;
  const states = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const timing = { duration: 280, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)' };

  function setControl(control, expanded) {
    control.setAttribute('aria-expanded', String(expanded));
    control.classList.add('nutracene-animated-toggle');
    if (!control.querySelector('.nutracene-toggle-icon')) {
      const icon = document.createElement('span');
      icon.className = 'nutracene-toggle-icon';
      icon.setAttribute('aria-hidden', 'true');
      control.appendChild(icon);
    }
    if (control.tagName === 'BUTTON') control.classList.toggle('active', expanded);
    const plus = control.querySelector('.icon-plus');
    const minus = control.querySelector('.icon-minus');
    if (plus) plus.style.display = expanded ? 'none' : 'inline';
    if (minus) minus.style.display = expanded ? 'inline' : 'none';
  }

  function animatePanel(element, control, expanded, isDetails) {
    const previous = states.get(element);
    // Layout pixels keep the animation accurate when the theme uses CSS zoom.
    const from = element.offsetHeight;
    previous?.animation?.cancel();
    const state = { expanded, animation: null, complete: null };
    states.set(element, state);
    setControl(control, expanded);

    // Measure the natural endpoint, then keep content available while closing.
    element.style.height = '';
    if (isDetails) element.open = expanded;
    else element.style.display = expanded ? 'block' : 'none';
    const to = element.offsetHeight;
    if (isDetails) element.open = true;
    else element.style.display = 'block';

    state.complete = () => {
      if (states.get(element) !== state) return;
      if (isDetails) element.open = expanded;
      else element.style.display = expanded ? 'block' : 'none';
      element.style.height = '';
      element.style.overflow = '';
      state.animation?.cancel();
      state.animation = null;
    };
    if (reducedMotion.matches || !element.animate || Math.abs(from - to) < 1) {
      state.complete();
      return;
    }
    element.style.overflow = 'hidden';
    state.animation = element.animate({ height: [`${from}px`, `${to}px`] }, timing);
    state.animation.onfinish = state.complete;
  }

  function finishParents(element) {
    for (let parent = element.parentElement; parent; parent = parent.parentElement) {
      const state = states.get(parent);
      if (state?.animation) state.complete();
    }
  }

  function initialize(root = document) {
    root.querySelectorAll('[id^="ProductInfo-"] summary, [id^="ProductInfo-"] button.collapsible, [id^="ProductInfo-"] button.collapsible-benefits').forEach((control) => {
      const details = control.closest('details.accordion-item');
      const panel = control.nextElementSibling;
      if (details) setControl(control, details.open);
      else if (panel?.matches('.collapsible-content, .collapsible-content-benefits')) {
        setControl(control, getComputedStyle(panel).display !== 'none');
      }
    });
  }

  // Capture before the older inline handlers, so each click has one controller.
  document.addEventListener('click', (event) => {
    const control = event.target.closest('summary, button.collapsible, button.collapsible-benefits');
    const group = control?.closest('[id^="ProductInfo-"]');
    if (!group) return;
    const details = control.tagName === 'SUMMARY' ? control.parentElement : null;
    const isDetails = details?.matches('details.accordion-item');
    const panel = isDetails ? details : control.nextElementSibling;
    if (!isDetails && !panel?.matches('.collapsible-content, .collapsible-content-benefits')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    // The older page-wide FAQ script can cap an adjacent product wrapper.
    // Its content must remain in normal flow when this controller expands it.
    if (control.parentElement.matches('.collapsible-wrapper, .collapsible-wrapper-benefits')) {
      control.parentElement.style.maxHeight = 'none';
    }
    finishParents(panel);
    const expanded = !(states.get(panel)?.expanded ?? (isDetails ? details.open : getComputedStyle(panel).display !== 'none'));
    if (expanded && isDetails) {
      group.querySelectorAll('details.accordion-item').forEach((other) => {
        if (other !== details && (states.get(other)?.expanded ?? other.open)) {
          animatePanel(other, other.querySelector('summary'), false, true);
        }
      });
    }
    animatePanel(panel, control, expanded, isDetails);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  reducedMotion.addEventListener('change', () => {
    if (!reducedMotion.matches) return;
    document.querySelectorAll('[id^="ProductInfo-"] details.accordion-item, [id^="ProductInfo-"] .collapsible-content, [id^="ProductInfo-"] .collapsible-content-benefits').forEach((panel) => {
      states.get(panel)?.complete?.();
    });
  });
})();

